import { push, ref } from "firebase/database";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { database } from "../firebase";

const Register = () => {
  const [form, setForm] = useState({ name: "", email: "", mobile: "", password: "" });
  const [msg, setMsg] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await push(ref(database, "admins"), form);
      setMsg("Admin created successfully!");
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      setMsg("Error creating admin. Try again.");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: "400px" }}>
      <h4 className="fw-bold mb-3">Create Admin Account</h4>
      {msg && <div className="alert alert-info">{msg}</div>}
      <form onSubmit={handleSubmit}>
        {["name", "email", "mobile", "password"].map((field) => (
          <div className="mb-3" key={field}>
            <label className="form-label text-capitalize">{field}</label>
            <input
              type={field === "password" ? "password" : "text"}
              className="form-control"
              required
              value={form[field]}
              onChange={(e) => setForm({ ...form, [field]: e.target.value })}
            />
          </div>
        ))}
        <button className="btn btn-primary w-100" type="submit">Create Account</button>
      </form>
    </div>
  );
};

export default Register;
